<template>
  <div>
    <div v-for="(day, d) in days" :key="'days' + d" class="grid">
      <div class="cell">{{ day.date }}</div>
      <div>
        <div v-for="(work, w) in day.work_types" :key="'day.work_types' + w">
          <div v-for="(report, r) in work.reports" :key="'day.work_types.report' + r">
            <StatisticProjectReportsBlankConfirmTableByDaysItem
              :work="work"
              :report="report"
              :confirmed="confirmed.work_types"
              :on-update="onUpdateWork"
              :notes="notes"
              :current-bill-id="currentBillId"
            />
          </div>
        </div>
        <div v-if="day.extras">
          <div class="grid_inner fw500">
            <div class="cell">
              <BaseCheckbox
                :value="day.extrasConfirmed"
                class="mr-2"
                @input="changeConfirm(day)"
              />
              {{
                getReportsSumByField(day.extras, 'approved_report') > 0
                  ? $formatTime(getReportsSumByField(day.extras, 'approved_report'))
                  : ''
              }}
            </div>
            <div class="d-flex">
              <div class="cell">{{ localStorage.translations.pages.finance['period-table']['total-extra'] }}</div>
              <div v-if="notes" class="cell"></div>
              <div v-if="notes" class="cell"></div>
            </div>
          </div>
          <div v-for="(extra, e) in day.extras" :key="'day.extra' + e">
            <div v-for="(report, r) in extra.reports" :key="'day.extra.report' + r">
              <StatisticProjectReportsBlankConfirmTableByDaysItem
                :work="extra"
                :report="report"
                is-extra
                :confirmed="confirmed.extras"
                :on-update="onUpdateExtra"
                :notes="notes"
                :current-bill-id="currentBillId"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import StatisticProjectReportsBlankConfirmTableByDaysItem
  from "components/timeControl/reports/blank/confirm/StatisticProjectReportsBlankConfirmTableByDaysItem";
import BaseCheckbox from "components/base/BaseCheckbox";

export default {
  name: "StatisticProjectReportsBlankConfirmTableByDays",
  components: {BaseCheckbox, StatisticProjectReportsBlankConfirmTableByDaysItem},
  props: {
    data: {
      type: Object,
      default: () => {
        return {}
      }
    },
    confirmed: {
      type: Object,
      default: () => {
        return {
          work_types: [],
          extras: []
        }
      }
    },
    onUpdateWork: {},
    onUpdateExtra: {},
    notes: Boolean,
    currentBillId: {
      type: [Number, String],
      default: null,
    },
  },
  computed: {
    days() {
      let days = {}
      let arr = ['work_types', 'extras']
      for (let r in arr) {
        let field = arr[r]
        for (const workKey in this.data[field]) {
          const currentWork = this.data[field][workKey]
          for (const dayKey in currentWork.days) {
            let date = dayKey.split('-')
            if (currentWork.days[dayKey].reports) {
              let data = {
                name: currentWork.name,
                measure: currentWork.measure,
                is_hourly: currentWork.is_hourly,
                reports: currentWork.days[dayKey].reports.filter((i) => i.approved_report > 0)
              }
              if (data.reports.length > 0) {
                if (days[dayKey]) {
                  if (!days[dayKey][field]) {
                    days[dayKey][field] = {}
                  }
                  days[dayKey][field][workKey] = data
                } else {
                  days[dayKey] = {}
                  days[dayKey][field] = {}
                  days[dayKey][field][workKey] = data
                }
                days[dayKey].date = date[2] + '/' + date[1]
                // get value for checkbox from all extras by one day
                if (days[dayKey].extras) {
                  let reports = []
                  let extras = Object.values(days[dayKey].extras).map(data => data.reports)
                  for (let e in extras)
                    for (let r in extras[e])
                      reports.push(extras[e][r])
                  let confirmed = reports.map(data => data.id)
                  days[dayKey].extrasConfirmed = confirmed.every(cur => {
                    return this.confirmed.extras.includes(Number(cur))
                  })
                    ? true
                    : confirmed.every(cur => {
                      return !this.confirmed.extras.includes(Number(cur))
                    })
                      ? false
                      : null
                }
              }
            }
          }
        }
      }
      return Object.keys(days).sort().reduce(
        (accumulator, index) => ({
          ...accumulator,
          [index]: days[index]
        }), {}
      )
    },
  },
  methods: {
    isSelectable(report) {
      const isEmptyBillId = (value) => {
        return value === null || value === undefined || value === '' || value === 'null'
      }
      const isSameBillId = (value, currentBillId) => {
        if (isEmptyBillId(value) || isEmptyBillId(currentBillId)) return false
        return String(value) === String(currentBillId)
      }
      return report
        && report.approved_report > 0
        && report.client_report_status !== 'signed'
        && report.client_report_status !== 'approved'
        && (isEmptyBillId(report.client_bill_id) || isSameBillId(report.client_bill_id, this.currentBillId))
    },
    getReportsSumByField(items, field) {
      return Object.values(items)
        .map(data => data.reports)
        .reduce((sum, current) => {
          return sum + current.reduce((sum, current) => {
            if (this.confirmed.extras.includes(current.id))
              return sum + current[field]
            else return sum
          }, 0)
        }, 0)
    },
    changeConfirm(day) {
      let reports = []
      let work = Object.values(day.extras).map(data => data.reports)
      for (let i in work) {
        for (let report in work[i]) {
          if (this.isSelectable(work[i][report])) {
            reports.push(work[i][report].id)
          }
        }
      }
      if (this.onUpdateExtra) this.onUpdateExtra(reports, !day.extrasConfirmed)
    }
  }
}
</script>
